// https://fusion-api.dev.mos.coke.com/v1/projects

import { briefApi } from 'api'
import { ApiResponse } from 'types/common/utils'

export interface ProjectStatus {
  errors: number
  warnings: number
}

export const fetchProjectsStatus = () => briefApi.get<ApiResponse<ProjectStatus>>('/projects/statuses')
